/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightExchangeConfirmationResponse
 */
export interface FlightExchangeConfirmationResponse {
  /**
   *
   * @type {string}
   * @memberof FlightExchangeConfirmationResponse
   */
  exchangeId: string;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeConfirmationResponse
   */
  test: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeConfirmationResponse
   */
  status: FlightExchangeConfirmationResponseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeConfirmationResponse
   */
  reasonCode: string;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeConfirmationResponse
   */
  nativeConfirmed: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeConfirmationResponse
   */
  canConfirm: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangeConfirmationResponse
   */
  canRecover: boolean;
}

/**
 * @export
 */
export const FlightExchangeConfirmationResponseStatusEnum = {
  Unavailable: "unavailable",
  Ready: "ready",
  NeedsAttention: "needs_attention",
} as const;
export type FlightExchangeConfirmationResponseStatusEnum =
  (typeof FlightExchangeConfirmationResponseStatusEnum)[keyof typeof FlightExchangeConfirmationResponseStatusEnum];

/**
 * Check if a given object implements the FlightExchangeConfirmationResponse interface.
 */
export function instanceOfFlightExchangeConfirmationResponse(
  value: object
): value is FlightExchangeConfirmationResponse {
  if (!("exchangeId" in value) || value["exchangeId"] === undefined)
    return false;
  if (!("test" in value) || value["test"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("reasonCode" in value) || value["reasonCode"] === undefined)
    return false;
  if (!("nativeConfirmed" in value) || value["nativeConfirmed"] === undefined)
    return false;
  if (!("canConfirm" in value) || value["canConfirm"] === undefined)
    return false;
  if (!("canRecover" in value) || value["canRecover"] === undefined)
    return false;
  return true;
}

export function FlightExchangeConfirmationResponseFromJSON(
  json: any
): FlightExchangeConfirmationResponse {
  return FlightExchangeConfirmationResponseFromJSONTyped(json, false);
}

export function FlightExchangeConfirmationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeConfirmationResponse {
  if (json == null) {
    return json;
  }
  return {
    exchangeId: json["exchange_id"],
    test: json["test"],
    status: json["status"],
    reasonCode: json["reason_code"],
    nativeConfirmed: json["native_confirmed"],
    canConfirm: json["can_confirm"],
    canRecover: json["can_recover"],
  };
}

export function FlightExchangeConfirmationResponseToJSON(
  json: any
): FlightExchangeConfirmationResponse {
  return FlightExchangeConfirmationResponseToJSONTyped(json, false);
}

export function FlightExchangeConfirmationResponseToJSONTyped(
  value?: FlightExchangeConfirmationResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    exchange_id: value["exchangeId"],
    test: value["test"],
    status: value["status"],
    reason_code: value["reasonCode"],
    native_confirmed: value["nativeConfirmed"],
    can_confirm: value["canConfirm"],
    can_recover: value["canRecover"],
  };
}
